import styled from 'styled-components';

export default styled.div`
    top: 0;
    background-color: ${(props) => props.theme.colors.background.container};
`;
